<template>
  <main class="t-page-lk t-page-lk-wrapper">
    <!-- <ui-event-banner-cmp class="t-lk-container" /> -->
    <transition name="page">
      <router-view></router-view>
    </transition>
  </main>
</template>

<script>
// import UIBanner from './banner/banner.vue'

export default {
  name: 'lk',
  // components: {
  //     'ui-event-banner-cmp': UIBanner
  // }
}
</script>

<style lang="sass">
@import "./index"
</style>



// WEBPACK FOOTER //
// src/templates/pages/lk/index.vue